import React, { ReactElement } from 'react';

import { OzContent } from '../../design-styles/content/Content';
import { OzGrid } from '../../design-styles/grid/Grid';
import { GRID_CELL_SIZE } from '../../design-styles/grid/grid-cell/GRID_CELL_SIZE';
import { OzGridCell } from '../../design-styles/grid/grid-cell/GridCell';
import { OzGridRow } from '../../design-styles/grid/grid-row/GridRow';
import { IParentProps } from '../../shared/types/IParentProps';
import { IQATestableProps } from '../../shared/types/IQATestableProps';

import styles from './Modal.module.css';
import { OzModalCloseButton } from './ModalCloseButton';

type IModalContentProps = IParentProps & IQATestableProps;

export function OzModalContent (props: IModalContentProps): ReactElement {
    const { children }: IModalContentProps = props;

    return (
        <div className="fixed z-20 flex flex-col h-full items-center justify-center left-0 top-0 w-full">
            <OzContent>
                <OzGrid>
                    <OzGridRow>
                        <OzGridCell
                            smSize={GRID_CELL_SIZE.COLUMN_4}
                            mdSize={GRID_CELL_SIZE.COLUMN_4}
                            mdOffset={GRID_CELL_SIZE.COLUMN_2}
                            lgSize={GRID_CELL_SIZE.COLUMN_6}
                            lgOffset={GRID_CELL_SIZE.COLUMN_3}
                        >
                            <div className={`relative bg-white-500 rounded-sm shadow-modal p-3 ${styles.modalShadow}`}>
                                <div className="flex gap-3 justify-between">
                                    <div>
                                        {children}
                                    </div>
                                    <OzModalCloseButton />
                                </div>
                            </div>
                        </OzGridCell>
                    </OzGridRow>
                </OzGrid>
            </OzContent>
        </div>
    );
}
